import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Lock, Mail, AlertCircle } from 'lucide-react';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login(email, password);
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Identifiants incorrects');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#020202] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-10">
          <a href="/" className="text-3xl font-bold text-gold inline-block" data-testid="login-logo">
            <span className="font-['Playfair_Display']">YENO</span>
            <span className="font-light text-white/80 ml-2">Transport</span>
          </a>
          <p className="text-white/40 mt-2">Administration</p>
        </div>

        {/* Form Card */}
        <div className="card-dark p-8">
          <h2 className="text-2xl font-bold mb-6 font-['Playfair_Display'] text-center" data-testid="login-title">
            Connexion
          </h2>

          {error && (
            <div className="bg-red-500/10 border border-red-500/30 text-red-400 px-4 py-3 mb-6 flex items-center gap-3" data-testid="login-error">
              <AlertCircle size={18} />
              <span>{error}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="label-gold">Email</label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" size={18} />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="input-dark w-full pl-10"
                  placeholder="admin@yenotransport.com"
                  data-testid="input-email"
                />
              </div>
            </div>

            <div>
              <label className="label-gold">Mot de passe</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" size={18} />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="input-dark w-full pl-10"
                  placeholder="••••••••"
                  data-testid="input-password"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn-gold w-full disabled:opacity-50"
              data-testid="login-submit-btn"
            >
              {loading ? 'Chargement...' : 'Se connecter'}
            </button>
          </form>
        </div>

        {/* Back to site */}
        <div className="text-center mt-6">
          <a href="/" className="text-white/40 hover:text-white/60 text-sm" data-testid="back-to-site">
            ← Retour au site
          </a>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
